import { useMemo } from 'react';
import useSWR, { SWRConfiguration } from 'swr';
// utils
import axios, { endpoints, fetcher } from 'src/utils/axios';

// types

// ----------------------------------------------------------------------

// XỬ LÝ API THÔNG TIN TRƯỜNG HỌC

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export function useGetSchoolInfor(option?: SWRConfiguration) {
  const URL = endpoints.school.root;

  const { data, isLoading, error, isValidating, mutate } = useSWR(URL, fetcher, option);

  const school = data?.data;
  const memoizedValue = useMemo(
    () => ({
      data: {
        status: data?.status,
        message: data?.message,
        data: {
          ...school,
        },
      },
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}

// ----------------------------------------------------------------------

export async function updateSchoolInfor(formData: any) {
  const URL = endpoints.school.update_infor;

  const { data } = await axios.put(URL, formData);

  return data;
}

// ----------------------------------------------------------------------

export async function updateSchoolSMTP(payload: any) {
  const URL = endpoints.school.update_smtp;

  const { data } = await axios.put(URL, payload);

  return data;
}

// ----------------------------------------------------------------------
